import { useCartStore } from '@/stores/cart';
import { storeToRefs } from 'pinia';

export function useCart() {
  const cartStore = useCartStore();
  const { 
    items, 
    subtotal, 
    total, 
    discountAmount,
    appliedCouponCode,
    couponLoading,
    couponError,
    loading, 
    error, 
    itemsCount, 
    isEmpty 
  } = storeToRefs(cartStore);

  const addToCart = async (
    entityType: string, 
    entityId: string, 
    quantity: number = 1,
    productInfo?: { name: string; price: number; image?: string | null; isDigital?: boolean }
  ) => {
    return await cartStore.addItem(entityType, entityId, quantity, productInfo);
  };

  const updateQuantity = async (itemId: string, quantity: number) => {
    return await cartStore.updateQuantity(itemId, quantity);
  };

  const removeFromCart = async (itemId: string) => {
    return await cartStore.removeItem(itemId);
  };

  return {
    items,
    subtotal,
    total,
    discountAmount,
    appliedCouponCode,
    couponLoading,
    couponError,
    loading,
    error,
    itemsCount,
    isEmpty,
    loadCart: cartStore.loadCart,
    addToCart,
    updateQuantity,
    removeFromCart,
    applyCoupon: cartStore.applyCoupon,
    removeCoupon: cartStore.removeCoupon,
    clearCart: cartStore.clearCart,
    syncLocalCartToBackend: cartStore.syncLocalCartToBackend
  };
}
